<template>
  <div class="child-list-item-select">
    <router-link v-if="route" :to="'/children/' + child.id">
      <span v-on:click="selectChild(child)">
        <div :class="{
          row: true,
          child: true,
          selected: selected
        }">
          <div :class="getThumbnailWidth()">
            <child-thumbnail :key="child.id" :childReset="childReset" :child="child"></child-thumbnail>
          </div>
          <div :class="getContentWidth()">
            <h3>{{ child.first_name }}</h3>
            <p>{{ child.last_name_suffix }} {{ child.last_name }}</p>
          </div>
        </div>
      </span>
    </router-link>
    <div v-else class="row child" :class="{selected: selected}" v-on:click="selectChild(child)">
      <div :class="getThumbnailWidth()">
        <child-thumbnail :key="child.id" :child="child"></child-thumbnail>
      </div>
      <div :class="getContentWidth()">
        <div class="row">
          <div class="col-6">
            <h3>{{ child.first_name }}</h3>
            <p>{{ child.last_name_suffix }} {{ child.last_name }}</p>
          </div>
          <div class="col-6 d-flex justify-content-end align-items-start text-end">
            <div v-if="showMessageInfo === true && messageInfo && messageInfo.last_message">
              <p class="chat-message-timestamp">
                {{ formatMessageDateShort(messageInfo.last_message.created_at) }}
              </p>
              <div
                  v-if="messageInfo && messageInfo.unread_messages > 0"
                  class="badge badge-danger badge-unread-chat-messages"
              >
                {{ messageInfo.unread_messages }}
              </div>
            </div>
          </div>
        </div>
          <span class="chat-message">
            <p v-if="showMessageInfo === true && messageInfo && messageInfo.last_message">
              <span class="text-muted">
                <span v-if="messageInfo.last_message && messageInfo.last_message.enterd_by && messageInfo.last_message.enterd_by === 1">
                  {{ messageInfo.last_message.name || 'Verzorger' }}:
                </span>
                <span v-else>
                  U:
                </span>
                <span v-if="messageInfo.last_message.text.length > 110">
                  {{ messageInfo.last_message.text.substr(0, 110) + '...' }}
                </span>
                <span v-else>
                  {{ messageInfo.last_message.text }}
                </span>
              </span>
            </p>
            <p v-else-if="showMessageInfo === true && messageInfo === null"
              class="chat-message"
            >
              <span class="text-muted">
                Geen berichten
              </span>
            </p>
          </span>
      </div>
    </div>
  </div>
</template>

<script>
import ChildThumbnail from '@/components/Child-Thumbnail'
export default {
  name: 'child-list-item-select',
  props: ['child', 'selected', 'route', 'childReset', 'showMessageInfo', 'messageInfo'],
  components: {
    ChildThumbnail
  },
  data () {
    return {
    }
  },
  methods: {
    getThumbnailWidth () {
      if (this.showMessageInfo === true) {
        return 'col-4 col-sm-3'
      }
      return 'col-4 col-sm-4'
    },
    getContentWidth () {
      if (this.showMessageInfo === true) {
        return 'col-8 col-sm-9'
      }
      return 'col-8 col-sm6-8'
    },
    selectChild (child) {
      if (child.id_child) {
        child.id = child.id_child
      }
      if (child.id) {
        child.id_child = child.id
      }
      this.$store.commit('SET_SELECTED_CHILD', child)
    }
  }
}
</script>

<style scoped>
  * {
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    user-select: none;
  }
  h3, p {
    margin: 0;
  }
  .child {
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .child:hover,
  .child .selected {
    background: white;
  }
  a {
    text-decoration: none;
    color: #666;
  }
  .chat-message-timestamp,
  .chat-message {
    font-size: 13px;
  }
  .badge-unread-chat-messages {
    background: #e85e0c !important;
    min-height: 9px;
    min-width: 9px;
    border-radius: 9px;
  }
  .chat-message-timestamp {
    margin-top: 8px;
  }
</style>
